// extracted by mini-css-extract-plugin
module.exports = {"root":"y_cx","title":"y_f","subtitle":"y_R","richText":"y_b6"};